import { render, staticRenderFns } from "./SOVLite.vue?vue&type=template&id=bf645d6c&scoped=true"
import script from "./SOVLite.vue?vue&type=script&lang=js"
export * from "./SOVLite.vue?vue&type=script&lang=js"
import style0 from "./SOVLite.vue?vue&type=style&index=0&id=bf645d6c&prod&scoped=true&lang=css"
import style1 from "./SOVLite.vue?vue&type=style&index=1&id=bf645d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf645d6c",
  null
  
)

export default component.exports